import { connect } from 'react-redux';
import CallbackJrUpgPage from './CallbackJrUpgPage';
import {
	getTicketTransactionById,
	resetPage,
	resetMeta
} from '../../actions/CallbackJrUpgPage';

const mapsStateToProps = state => ({
	callbackJrUpgPageProps: state.callbackJrUpgPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getTicketTransactionById(id) {
		dispatch(getTicketTransactionById(id));
	},
	resetPage() {
		dispatch(resetPage());
	},
	resetMeta() {
		dispatch(resetMeta());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(CallbackJrUpgPage);
